// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-templates-basic-template-js": () => import("/opt/build/repo/src/templates/basicTemplate.js" /* webpackChunkName: "component---src-templates-basic-template-js" */),
  "component---src-pages-404-js": () => import("/opt/build/repo/src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("/opt/build/repo/src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-json-at-buildtime-js": () => import("/opt/build/repo/src/pages/json-at-buildtime.js" /* webpackChunkName: "component---src-pages-json-at-buildtime-js" */),
  "component---src-pages-yml-at-buildtime-js": () => import("/opt/build/repo/src/pages/yml-at-buildtime.js" /* webpackChunkName: "component---src-pages-yml-at-buildtime-js" */)
}

